import commonCopyText from "../common.copyText";

export default {
  ...commonCopyText,
  accountingOtherCredits: "All Other Credits",
  accountingSudsAndCuds: "SUDs and CUDs",
  announceKitButtonLabel: "What's New?",
  confirmation: "Confirmation",
  confirmationNo: "No",
  confirmationYes: "Yes",
  creditBreakdownTableTitle: "Total Credits Breakdown",
  creditDescriptionCUD: "Resource-based Committed Use contracts purchased for Compute Engine in return for deeply discounted prices for VM usage.",
  creditDescriptionCUDDollarBase: "Spend-based Committed Use contracts purchased for services in exchange for your commitment to spend a minimum amount.",
  creditNameCUD: "Committed Use Discount",
  creditNameSubscriptionBenefit: "Subscription Benefit",
  csvHeaderName: "Name",
  datePickerModalTitle: "Custom Date Range",
  dateRangeControlsButton30Days: "30 Days",
  dateRangeControlsButtonLastBillingInvoice: "Last Month",
  dateRangeControlsButtonMTD: "MTD",
  dateRangeControlsButtonYTD: "YTD",
  emptyPlaceholderInsufficientPermission: "Insufficient Permissions",
  globalDateSelectorApplyButtonLabel: "Apply",
  globalDateSelectorTitle: "Global Date Selector",
  globalDateSelectorRemoveDateButtonCaption: "Remove Date",
  globalDateSelectorCustomDateRangeLabel: "Custom",
  globalDateSelectorTooltipCaption: "%switch% global date",
  globalDateNotAvailableMessage: "Global date is not available on this page",
  labelApplicatorAddRuleButtonLabel: "Add New",
  labelApplicatorButtonApply: "Apply",
  labelApplicatorLabelKey: "Key",
  labelApplicatorPlaceholderValue: "Enter Values",
  labelApplicatorPlaceholderValueAdditional: "Enter Additional Value (optional)",
  labelApplicatorRemoveAllButtonLabel: "Remove All",
  labelApplicatorTitle: "Filter Page by Labels",
  labelBadgeAddFilter: 'Add Filter',
  labelSuggestionsError: "We were unable to load your labels, but you can still type your own.",
  moreOptionsLabel: "more",
  meterCaptionOfYourBill: "of your bill",
  meterCaptionSinceLastMonth: "vs. this time last month",
  meterTitleLastMonthTotalSpend: "Last Month Total Spend",
  meterTitleLastMonthTotalSpendFiscal: "Last Fiscal Month Total Spend",
  meterTitleMSTD: "Monthly Spend To Date",
  meterTitleMSTDFiscal: "Fiscal Month Spend To Date",
  meterTitleSavingsOpportunities: "Savings Opportunities",
  meterValueNoChange: "No Change",
  modalTitleCreateBudget: "Create Budget",
  noData: "No Data To Display",
  none: "none",
  notConfiguredPlaceholderAdminLink: "Take me to the Admin Page",
  notConfiguredPlaceholderText: "It appears this feature is not yet configured. Please consult the Admin Page for more information.",
  notConfiguredPlaceholderTitle: "Not Configured",
  notFoundHeader: "Page not found.",
  notFoundLinkLabel: "Click Here to Return Home",
  nullProjectId: "(no project)",
  paginationExplanation: "Showing %start% to %end% out of %total%",
  paginationStatusLabelOutOf: "out of",
  paginationStatusLabelRange: "%start% to %end%",
  paginationStatusLabelShowing: "Showing",
  rowLimitReached: "Row limit reached. To see the full result, you may want to export the dataset as a CSV",
  ruleAnd: "and",
  ruleOr: "or",
  sectionTitleCostExplorer: "Cost Explorer",
  sectionTitleSpendByProject: "Spend By Project",
  shareButton: "Share",
  shareButtonTooltip: "Link copied to clipboard.",
  tableAriaToggleSortBy: "Toggle Sort",
  tenantModalPlaceholder: "Select Tenant",
  tenantModalChangeActiveTenantTitle: "Change Active Tenant",
  tenantModalChangeMspTenantTitle: "Change MSP Tenant",
  topNavDropdownItemChangeMspTenant: "Change MSP Tenant",
  topNavDropdownItemDocumentation: "Documentation",
  topNavDropdownItemSelectMspTenant: "Select MSP Tenant",
  topNavDropdownItemInternalAdmin: "Internal Admin",
  topNavDropdownItemSettings: "Settings",
  topNavDropdownItemSwitchTenant: "Switch Tenant",
  topNavDropdownLogout: "Logout",
  topNavNetCostToggleTooltip: "Net Cost Coming Soon",
  total: "Total",
  totals: "Totals",
  totalsPieChartOverallTotal: "Overall Total",
  uberControlsAdvancedDescription: "Specify your preferred drilldown order, then click in to the graph.",
  uberControlsAggregation: "Aggregation",
  uberControlsAll: "All",
  uberControlsDatePickerLabelEnd: "End Date",
  uberControlsDatePickerLabelStart: "Start Date",
  uberControlsDatePickerTitle: "Custom Date Range",
  uberControlsDefaultAggregations: "Use Default Aggregations",
  uberControlsGroupedBy: "Grouped By: ",
  uberControlsToggleAdvanced: "Toggle Advanced Controls",
  uberEmptyPlaceholderText: "No Usage Data to Display",
};
